var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPrinting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.98 115.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-printing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.62 20.19 23.96 20.19 2 20.19 2 81.04 34.62 81.04"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "97.36 81.04 129.98 81.04 129.98 20.19 106.77 20.19 97.36 20.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "34.62 20.19 26.96 20.19 26.96 39.01 34.62 39.01 97.36 39.01 105.04 39.01 105.04 20.19 97.36 20.19 96.16 20.19"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.62,
    y: 2,
    width: 62.73,
    height: 37.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.62,
    y: 65.99,
    width: 62.73,
    height: 47.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 27.09,
    y1: 65.99,
    x2: 104.88,
    y2: 65.99
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.62,
    cy: 49.99,
    r: 3.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.56,
    y1: 94.85,
    x2: 67.87,
    y2: 94.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.87,
    y1: 83.4,
    x2: 82.61,
    y2: 83.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinting);
export default __webpack_public_path__ + "static/media/icon-printing.8f9c4e6867739358bbad636e9fc5781a.svg";
export { ForwardRef as ReactComponent };